import { Button, Typography } from "@suraasa/placebo-ui"
import { ArrowRight } from "iconoir-react"
import { TooltipRenderProps } from "react-joyride"
import { useNavigate } from "react-router-dom"

const OnboardingStep = (props: TooltipRenderProps) => {
  const navigate = useNavigate()
  const { index, primaryProps, step, isLastStep, size } = props

  const handleNext = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    // Check if step has custom route data
    if (step.data?.route) {
      navigate(step.data.route)
    }

    primaryProps.onClick(e)
  }
  return (
    <div className="flex min-h-[168px] w-full max-w-[calc(100vw_-_32px)] flex-col justify-between overflow-hidden rounded-xl bg-white p-2.5 sm:w-[345px] sm:max-w-none">
      <div>{step.content}</div>
      <div className="flex w-full items-center justify-between">
        <Typography variant="preTitle" className="text-onSurface-500">
          {index + 1} OF {size}
        </Typography>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            color="black"
            endAdornment={!isLastStep ? <ArrowRight /> : undefined}
            onClick={handleNext}
          >
            {isLastStep ? "Done" : "Next"}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OnboardingStep
